<template>
  <div v-if="bgLayout === 'center'" class="center-login-container" :style="{ 'background-image': `url(${settingData.bgImage})` }">
    <div class="logo"><img src="../../assets/images/logo1.png"/></div>
    <div class="center-login-content">
      <section class="link-container" :style="{ 'background-color': settingData.inputBgColor, 'border-color': settingData.inputBorderColor }">
        <div class="container">
          <div v-for="(item, index) in linkList" :key="index" v-show="item.groupSize > 0">
            <p class="link-title" :style="{ 'color': settingData.inputBorderColor }">{{ item.groupName }}</p>
            <div class="link-items" >
              <div class="link-cell" @mouseover.self="handleMouseOver"  @mouseleave.self="handleMmouseleave" v-for="(i, idx) in item.linkList" :key="idx" @click="doClickLocation(i.linkAddr, i.id)" :style="{ 'background': settingData.inputBgColor, 'border-color': settingData.inputBorderColor }">
                <span class="number" :style="{ 'color': settingData.inputBorderColor }">{{ idx > 9 ? idx : `0${idx}` }}</span>
                <span class="name" :style="{ 'color': settingData.buttonColor }">{{ i.linkName }}</span>
              </div>
            </div>
          </div>
        </div>
        <span class="center-login-triangle" :style="{ 'border-top-color': settingData.fontColor }"></span>
      </section>
      <div class="center-login-link" :style="{ 'color': settingData.fontColor }">&gt;&gt;&gt;&nbsp;{{ $t('loginPage.wbll') }}&nbsp;&lt;&lt;&lt;</div>
      <footer class="center-login-footer">© 2020 {{ $t('loginPage.bq') }} ICP</footer>
    </div>
  </div>
  <div v-else class="right-login-container" :style="{ 'background-image': `url(${settingData.bgImage})` }">
    <div class="right-login-content">
      <div class="logo"><img src="../../assets/images/logo1.png"/></div>
      <!-- <p class="right-login-title" :style="{ 'color': settingData.fontColor }">{{ $t('loginPage.tysfglpt') }}</p> -->

      <!-- 外部链接 -->
      <section class="link-container" :style="{ 'background-color': settingData.loginBgColor, 'border-color': settingData.inputBorderColor }">
        <div class="container">
          <div v-for="(item, index) in linkList" :key="index" v-show="item.groupSize > 0">
            <p class="link-title" :style="{ 'color': settingData.fontColor }">{{ item.groupName }}</p>
            <div class="link-items" >
              <div class="link-cell" @mouseover.self="handleMouseOver" @mouseleave.self="handleMmouseleave" v-for="(i, idx) in item.linkList" :key="idx" @click="doClickLocation(i.linkAddr, i.id)">
                <span class="number" :style="{ 'color': settingData.buttonColor }">{{ idx > 9 ? idx : `0${idx}` }}</span>
                <span class="name" :style="{ 'color': settingData.fontColor }">{{ i.linkName }}</span>
              </div>
            </div>
          </div>
        </div>

        <span class="right-login-triangle" :style="{ 'border-top-color': settingData.loginBgColor }"></span>
      </section>

      <div class="right-login-link" :style="{ 'color': settingData.fontColor }">&gt;&gt;&gt;&nbsp;{{ $t('loginPage.wbll') }}&nbsp;&lt;&lt;&lt;</div>
      <footer class="right-login-footer">© 2020 {{ $t('loginPage.bq') }} ICP</footer>
    </div>
  </div>
</template>

<script>
import { session } from '../../libs/location'
export default {
  computed: {
    settingData () {
      return this.$store.state.settingData
    }
  },
  data () {
    return {
      bgLayout: 'center',
      linkList: []
    }
  },
  created () {
    this.bgLayout = this.$store.state.settingData.bgLayout

    // 设置语言
    if (session.getItem('userInfo')) this.$i18n.locale = JSON.parse(session.getItem('userInfo')).languageSign || 'zh-CN'
    this.doInit()
  },
  methods: {
    handleMouseOver (e) {
      e.target.style.background = this.$store.state.settingData.buttonColor
      e.target.children[0].style.color = '#fff'
      e.target.children[1].style.color = '#fff'
    },
    handleMmouseleave (e) {
      e.target.style.background = '#fff'
      if (this.bgLayout === 'center') {
        e.target.children[0].style.color = this.$store.state.settingData.inputBorderColor
        e.target.children[1].style.color = this.$store.state.settingData.buttonColor
      } else {
        e.target.children[0].style.color = this.$store.state.settingData.buttonColor
        e.target.children[1].style.color = this.$store.state.settingData.fontColor
      }
    },
    doInit () {
      this.$request.post('/sso/link/getLinkInfos').then(res => {
        let { code, data } = res.data
        if (code === 'OK') {
          this.linkList = data
        }
      })
    },
    doClickLocation (url, id) {
      window.open(url, `sso${id}`)
    }
  }
}
</script>

<style lang="less" scoped>
.center-login-container {
  width: 100vw;
  height: 100vh;
  background: url('../../assets/images/login-center-bg.jpg') center center no-repeat;
  background-size: cover;
  .logo {
    position: absolute;
    left: 60px;
    top: 40px;
    img {
      width: 126px;
    }
  }
  .center-login-content {
    width: 1400px;
    height: 100vh;
    position: relative;
    left: 50%;
    margin-left: -700px;
    display: flex;
    align-items: center;
    justify-content: center;
    .center-login-title {
      position: absolute;
      right: 0;
      left: 0;
      text-align: center;
      top: 14vh;
      font-size: 50px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 1;
    }
  }
  .center-login-link {
    font-size: 18px;
    color: #FFFFFF;
    position: absolute;
    bottom: 80px;
    left: 0;
    right: 0;
    text-align: center;
    cursor: pointer;
  }
  .center-login-footer {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    bottom: 40px;
    text-align: center;
    font-size: 14px;
    color: #999999;
  }
  .link-container {
    position: relative;
    width: 1400px;
    height: 70vh;
    overflow: hidden;
    padding: 28px;
    border-radius: 6px;
    background: #081857;
    border-image: linear-gradient(180deg, rgba(0, 169, 255, 1), rgba(10, 70, 144, 1)) 2 2;
    .container {
      overflow: hidden;
      overflow-y: auto;
      height: 65vh;
    }
    .link-title {
      font-size: 18px;
      font-weight: 500;
      color: #00A7FF;
      line-height: 25px;
      margin-top: 12px;
      margin-bottom: 24px;
    }
    .link-items {
      display: flex;
      flex-wrap: wrap;
      .link-cell {
        flex: 0 0 18%;
        margin-right: 24px;
        margin-bottom: 16px;
        display: flex;
        padding: 0 16px;
        align-items: center;
        height: 48px;
        background: #002C79;
        border-radius: 4px;
        border: 1px solid #073DBE;
        cursor: pointer;
        .number {
          flex: 0 0 34px;
          font-size: 18px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #00A7FF;
        }
        .name {
          flex: 1;
          font-size: 16px;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
    }
    .center-login-triangle {
      position: absolute;
      bottom: -22px;
      display: inline-block;
      left: 50%;
      transform: translateX(-50%);
      border-top: 22px solid #081857;
      border-left: 16px solid transparent;
      border-right: 16px solid transparent;
    }
  }
}

.right-login-container {
  width: 100vw;
  height: 100vh;
  background: url('../../assets/images/login-right-bg.png') center center no-repeat;
  background-size: cover;
  .right-login-content {
    width: 1400px;
    height: 100vh;
    position: relative;
    left: 50%;
    margin-left: -700px;
    display: flex;
    align-items: center;
    .logo {
      position: absolute;
      left: 0;
      top: 40px;
      img {
        width: 96px;
      }
    }
    .right-login-title {
      position: absolute;
      right: 84px;
      top: 14vh;
      text-align: center;
      font-size: 40px;
      font-weight: 600;
      color: #333333;
      line-height: 1;
    }
  }
  .right-login-link {
    font-size: 18px;
    color: #C8291D;
    position: absolute;
    bottom: 80px;
    left: 0;
    right: 0;
    text-align: center;
    cursor: pointer;
  }
  .right-login-footer {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    bottom: 40px;
    text-align: center;
    font-size: 14px;
    color: #999999;
  }
  .link-container {
    position: relative;
    width: 1400px;
    height: 70vh;
    overflow: hidden;
    padding: 28px;
    border-radius: 6px;
    background: #FFFFFF;
    // box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.16);
    .container {
      overflow: hidden;
      overflow-y: auto;
      height: 65vh;
      &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width : 10px;  /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }
      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
        background   : #ddd;
      }
      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        background   : #f5f5f5;
      }
    }
    .link-title {
      font-size: 18px;
      font-weight: 500;
      color: #C8291D;
      line-height: 25px;
      margin-top: 12px;
      margin-bottom: 24px;
    }
    .link-items {
      display: flex;
      flex-wrap: wrap;
      .link-cell {
        flex: 0 0 18%;
        margin-right: 24px;
        margin-bottom: 16px;
        display: flex;
        padding: 0 16px;
        align-items: center;
        height: 48px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid rgba(200, 41, 29, 0.2);
        cursor: pointer;
        .number {
          flex: 0 0 34px;
          font-size: 18px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #C8291D;
        }
        .name {
          flex: 1;
          font-size: 16px;
          font-weight: 400;
          color: #333333;
        }
      }
    }
    .right-login-triangle {
      position: absolute;
      bottom: -22px;
      display: inline-block;
      left: 50%;
      transform: translateX(-50%);
      border-top: 22px solid #FFF;
      border-left: 16px solid transparent;
      border-right: 16px solid transparent;
    }
  }
}
.link-hover {
  .name {
    color: #FFFFFF;
  }
}
</style>
